var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEquifaxLogoDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 16,
    viewBox: "0 0 60 16",
    fill: "none",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7272_3169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.157 3.74487L9.78334 5.52179H5.57766L5.26608 7.01362H9.00439L8.59947 8.79085H4.86147L4.45654 10.6955H8.87983L8.4749 12.5678H0.5L1.37229 8.63218L2.40038 3.74487H10.157Z",
    fill: "#A6A7A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0039 8.79085H16.2937L21.7451 15.4551H18.1004L15.7642 12.5675C14.8714 12.7492 13.9896 12.8095 13.0814 12.8226C12.1896 12.835 10.6556 12.6256 9.97003 11.9957C9.20198 11.2916 9.42742 9.97582 9.60128 8.96104C9.63615 8.75748 9.66896 8.566 9.69125 8.39403C9.7991 7.55059 10.0738 6.47186 10.562 5.77559C11.5084 4.42582 13.2962 4.22853 14.7986 4.28408C14.928 4.28887 15.0627 4.29267 15.201 4.29659C16.2336 4.32578 17.4744 4.36086 18.3499 4.85521C19.0427 5.2482 19.3587 5.84869 19.3155 6.66436C19.2862 7.20766 19.1715 7.84757 19.0769 8.37508C19.0502 8.52423 19.025 8.6644 19.0039 8.79085ZM13.6147 11.3614C15.1849 11.3739 15.5907 10.2227 15.8888 8.85438C15.9115 8.75046 15.9369 8.64138 15.9631 8.52886L15.9633 8.52807C16.2244 7.4087 16.5649 5.94906 15.0789 5.83944C13.463 5.72068 12.9237 7.21123 12.7115 8.6325C12.6935 8.75233 12.6702 8.88244 12.6457 9.01868L12.6456 9.01911C12.4661 10.02 12.2273 11.351 13.6147 11.3614Z",
    fill: "#A6A7A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8414 4.72846L30.0003 8.63218L29.1593 12.5678H32.3365L34.0499 4.72846H30.8414Z",
    fill: "#A6A7A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2115 4.72846L41.8378 6.2835H38.1619L37.8503 7.74341H40.9655L40.7785 8.63218L40.6539 9.20331H37.5075L36.7914 12.5678H33.5825L35.2647 4.72846H42.2115Z",
    fill: "#A6A7A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6236 4.72846H23.8634L22.6486 10.2827C22.5 10.9617 23.1257 11.3158 23.6622 11.3627C24.3522 11.4237 24.9712 10.9847 25.1406 10.2511L26.4178 4.72878H29.6263L28.3491 10.6003C27.8022 12.1311 26.5354 12.7322 25.1368 12.8823C24.2695 12.9758 23.3515 12.8966 22.5237 12.7581L19.658 9.26684L20.6236 4.72846Z",
    fill: "#A6A7A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1142 4.72846H49.0334L51.5566 8.66379L48.9713 11.0757L48.2236 4.72846H44.3298L38.9096 12.5678H41.1525L42.3048 10.8538H45.607L45.794 12.5678H50.5601L52.8026 10.1872L54.1111 12.5678H58.0985L55.4195 8.37806L59.5 4.72846H56.3848L54.3602 6.75981L53.1142 4.72846ZM45.1084 6.5057L43.3641 9.17171H45.42L45.1084 6.5057Z",
    fill: "#A6A7A9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7272_3169"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquifaxLogoDisabled);
export default __webpack_public_path__ + "static/media/equifax_logo_disabled.65ed599c90317ddc211ee208624efc63.svg";
export { ForwardRef as ReactComponent };